function cov_1r1gaxm2x5() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ShareFilled.tsx";
  var hash = "0410a4ef907f70dcb98924e742d173fd28d6f49a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ShareFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0410a4ef907f70dcb98924e742d173fd28d6f49a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1r1gaxm2x5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1r1gaxm2x5();
var Icon = (cov_1r1gaxm2x5().s[0]++, {
  name: 'share-filled',
  svg: "<path d=\"M13.45 5.01777L15.8161 7.38388C16.3042 7.87204 17.0957 7.87204 17.5838 7.38388C18.072 6.89572 18.072 6.10427 17.5838 5.61611L13.7547 1.78698C12.9085 0.940798 11.548 0.905023 10.6585 1.70556L6.36374 5.57088C5.8506 6.0327 5.80901 6.82307 6.27083 7.3362C6.73265 7.84934 7.52302 7.89094 8.03615 7.42911L10.95 4.8067V14C10.95 14.6903 11.5096 15.25 12.2 15.25C12.8903 15.25 13.45 14.6903 13.45 14V5.01777Z\" fill=\"currentColor\"/>\n  <path d=\"M4 9.74999C2.75736 9.74999 1.75 10.7574 1.75 12V20.5C1.75 21.4665 2.5335 22.25 3.5 22.25H20.5C21.4665 22.25 22.25 21.4665 22.25 20.5V12C22.25 10.7574 21.2426 9.74999 20 9.74999H18.05C16.8626 9.74999 15.9 10.7126 15.9 11.9V16.6C15.9 16.959 15.609 17.25 15.25 17.25H9.2C8.84101 17.25 8.55 16.959 8.55 16.6V11.9C8.55 10.7126 7.58741 9.74999 6.4 9.74999H4Z\" fill=\"currentColor\"/>"
});
export default Icon;